<template>
  <div class="goodsInfo" @click="toDetail(info.id)" style="cursor: pointer">
    <div class="goodsImgWrap">
      <img :src="info.imgUrl" alt="" class="goodsImg" />
      <div class="priview" v-if="info.projectType == 1">
        <img
          src="@/assets/imgs/index/preview.png"
          alt=""
          style="width: 100%; height: 100%"
        />
      </div>
    </div>
    <div :class="{'secondKinds':CheckCN(),'secondKindsEn':!CheckCN()}">
      {{ info.categoryName }}
    </div>
    <div class="infoList">
      <div class="title">{{ info.name }}</div>
      <div class="time">{{ info.timeInfo }}</div>
      <div class="address">
        <span class="detail">{{ info.venueName }}</span
        ><span class="city">{{ info.cityName }}</span>
      </div>
      <Price
        class="price"
        :price="info.sellingPrice"
        :highPrice="(showHighPrice && info.highestPrice) || ''"
        :onlyOnePrice="info.onlyOnePrice"
      />
    </div>
  </div>
</template>

<script>
import Price from "@/components/index/price.vue";
import { unionFlag } from "@/utils";
export default {
  name: "goodsInfo",
  data() {
    return {};
  },
  components: {
    Price,
  },
  props: {
    info: Object,
    showHighPrice: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toDetail(id) {
      let union = unionFlag();
      console.log(union);
      let { city } = this.$route.query;
      window.open(
        `/drama_pc/detail?id=${id}&city=${city}` +
          (union ? `&union=${union}` : ""),
        this.isFeishuOrDingding ? "_self" : "_blank"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.goodsInfo {
  margin-top: 32px;
  overflow: hidden;
  .clearfix;
  position: relative;
  .secondKinds {
    height: 22px;
    width: 80px;
    line-height: 22px;
    color: white;
    background-color: rgba(0, 0, 0, 0.76);
    position: absolute;
    top: 10px;
    font-size: 10px;
    left: -19px;
    text-align: center;
    transform: rotate(-45deg);
    -ms-transform: rotate(-45deg); /* IE 9 */
    -moz-transform: rotate(-45deg); /* Firefox */
    -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
    -o-transform: rotate(-45deg); /* Opera */
  }
  .secondKindsEn {
    height: 22px;
    padding: 0 4px;
    // mawidth: 80px;
    max-width: 154px;
    line-height: 22px;
    color: white;
    background-color: rgba(0, 0, 0, 0.76);
    position: absolute;
    text-align: center;
    top: 0;
    left: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .goodsInfo:nth-child(1) {
    margin-top: 24px;
  }
  .goodsImgWrap {
    float: left;
    position: relative;
    .goodsImg {
      width: 154px;
      height: 206px;
    }
    .priview {
      width: 32px;
      height: 21px;
      position: absolute;
      top: 0;
      right: 0;
      display: inline-block;
    }
  }
  .infoList {
    float: left;
    margin-left: 16px;
    width: 520px;
    position: relative;
    height: 206px;
    .title {
      color: #000;
      font-size: 16px;
      // height: 48px;
      line-height: 24px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .time {
      font-size: 13px;
      color: #222222;
      margin-top: 16px;
      height: 24px;
      line-height: 24px;
    }
    .address {
      font-size: 12px;
      line-height: 24px;
      color: #555555;
      // margin-top: 16px;
      margin-top: 4px;
      .detail {
        padding-right: 10px;
        border-right: 1px solid #ededed;
      }
      .city {
        padding-left: 10px;
      }
    }
    .price {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
</style>
